export const USER_PREFERENCES_MOBILE_MENU_FIXED_HEIGHT = '46px';
